export const loadConfig = async (configFileName: string) => {
  const response = await fetch(`./config/${configFileName}`);

  if (!response.ok) {
    throw new Error(`Failed to load config file: ${configFileName}`);
  }

  return response.json();
};
